import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  const scrollToPricing = () => {
    document.getElementById('pricing')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="bg-forest py-24 px-4 text-center relative overflow-hidden" data-id="element-46">
      {/* Decorative background elements */}
      <div className="absolute inset-0 opacity-10" data-id="element-47">
        <div className="absolute -top-20 -left-20 w-64 h-64 rounded-full border-[20px] border-parchment" data-id="element-48"></div>
        <div className="absolute -bottom-20 -right-20 w-80 h-80 rounded-full border-[20px] border-parchment" data-id="element-49"></div>
      </div>

      <div className="relative z-10 max-w-3xl mx-auto" data-id="element-50">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-4xl md:text-5xl font-playfair font-bold text-parchment mb-6" data-id="element-51">
          Comienza tu camino hacia el cuidado natural
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.2
      }} className="text-xl text-parchment/80 mb-4 font-light" data-id="element-52">
          Descarga la guía hoy y aprende a crear tus propias pomadas naturales.
          Tu piel te lo agradecerá.
        </motion.p>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.3
      }} className="text-amber font-semibold mb-10" data-id="element-53">
          ⚡ Oferta disponible por tiempo limitado
        </motion.p>

        <motion.button initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} onClick={scrollToPricing} className="bg-amber text-white px-12 py-6 rounded-full font-bold text-2xl hover:scale-105 transition-transform shadow-xl" data-id="element-54">
          Quiero Mi Guía Ahora
        </motion.button>
      </div>
    </section>;
}